import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Button from 'components/Button/Button';
import React from 'react';
import { QuestionComponents } from './builders/ConfigureQuestionModal';

const SingleStepForm = ({ questions }) => {
  const elements = questions?.map((question) => {
    const Component = QuestionComponents[question.question_type];

    return (
      <Paper elevation={0} key={question.id} sx={{ mb: 2, p: 2 }}>
        <Component.Preview question={question} />
      </Paper>
    );
  });

  return (
    <Box>
      {elements}
      <Box textAlign="center" mt={3}>
        <Button>Submit</Button>
      </Box>
    </Box>
  );
};

export default SingleStepForm;
